export default __webpack_public_path__ + "static/media/g2021-5.9e9b4282.jpeg";